module.exports = __webpack_public_path__ + "static/media/album.94ffc63a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/music/album.jpg
// module id = 703
// module chunks = 0